import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import Vue from 'vue';
import Router from 'vue-router';
import { normalizeURL } from 'ufo';
import { interopDefault } from './utils';
import scrollBehavior from './router.scrollBehavior.js';

var _2e37aa30 = function _2e37aa30() {
  return interopDefault(import('../pages/account-verification/index.vue'
  /* webpackChunkName: "pages/account-verification/index" */
  ));
};

var _563a53bb = function _563a53bb() {
  return interopDefault(import('../pages/bursaries/index.vue'
  /* webpackChunkName: "pages/bursaries/index" */
  ));
};

var _cf6eb07e = function _cf6eb07e() {
  return interopDefault(import('../pages/courses/index.vue'
  /* webpackChunkName: "pages/courses/index" */
  ));
};

var _17e7f774 = function _17e7f774() {
  return interopDefault(import('../pages/events/index.vue'
  /* webpackChunkName: "pages/events/index" */
  ));
};

var _a0489a6c = function _a0489a6c() {
  return interopDefault(import('../pages/faqs/index.vue'
  /* webpackChunkName: "pages/faqs/index" */
  ));
};

var _276fa864 = function _276fa864() {
  return interopDefault(import('../pages/forgot-password/index.vue'
  /* webpackChunkName: "pages/forgot-password/index" */
  ));
};

var _67e3d248 = function _67e3d248() {
  return interopDefault(import('../pages/general-preferences/index.vue'
  /* webpackChunkName: "pages/general-preferences/index" */
  ));
};

var _5879b402 = function _5879b402() {
  return interopDefault(import('../pages/interviews/index.vue'
  /* webpackChunkName: "pages/interviews/index" */
  ));
};

var _61d6f87a = function _61d6f87a() {
  return interopDefault(import('../pages/jobs/index.vue'
  /* webpackChunkName: "pages/jobs/index" */
  ));
};

var _662c15a2 = function _662c15a2() {
  return interopDefault(import('../pages/LoadTest.vue'
  /* webpackChunkName: "pages/LoadTest" */
  ));
};

var _468b2db2 = function _468b2db2() {
  return interopDefault(import('../pages/login/index.vue'
  /* webpackChunkName: "pages/login/index" */
  ));
};

var _2a7c3439 = function _2a7c3439() {
  return interopDefault(import('../pages/messages/index.vue'
  /* webpackChunkName: "pages/messages/index" */
  ));
};

var _053754fe = function _053754fe() {
  return interopDefault(import('../pages/mock-interviews/index.vue'
  /* webpackChunkName: "pages/mock-interviews/index" */
  ));
};

var _bc4c9164 = function _bc4c9164() {
  return interopDefault(import('../pages/my-details/index.vue'
  /* webpackChunkName: "pages/my-details/index" */
  ));
};

var _68d8c520 = function _68d8c520() {
  return interopDefault(import('../pages/my-jobs/index.vue'
  /* webpackChunkName: "pages/my-jobs/index" */
  ));
};

var _23ec0b83 = function _23ec0b83() {
  return interopDefault(import('../pages/notification-preferences/index.vue'
  /* webpackChunkName: "pages/notification-preferences/index" */
  ));
};

var _1b27f271 = function _1b27f271() {
  return interopDefault(import('../pages/notifications/index.vue'
  /* webpackChunkName: "pages/notifications/index" */
  ));
};

var _d91f436e = function _d91f436e() {
  return interopDefault(import('../pages/saved-jobs/index.vue'
  /* webpackChunkName: "pages/saved-jobs/index" */
  ));
};

var _b588e360 = function _b588e360() {
  return interopDefault(import('../pages/settings/index.vue'
  /* webpackChunkName: "pages/settings/index" */
  ));
};

var _c23d582a = function _c23d582a() {
  return interopDefault(import('../pages/university-management/index.vue'
  /* webpackChunkName: "pages/university-management/index" */
  ));
};

var _102512eb = function _102512eb() {
  return interopDefault(import('../pages/welcome/index.vue'
  /* webpackChunkName: "pages/welcome/index" */
  ));
};

var _e8c9ecf0 = function _e8c9ecf0() {
  return interopDefault(import('../pages/account/create.vue'
  /* webpackChunkName: "pages/account/create" */
  ));
};

var _a70fe6d4 = function _a70fe6d4() {
  return interopDefault(import('../pages/account/edit.vue'
  /* webpackChunkName: "pages/account/edit" */
  ));
};

var _da7454f4 = function _da7454f4() {
  return interopDefault(import('../pages/account/verify-university.vue'
  /* webpackChunkName: "pages/account/verify-university" */
  ));
};

var _1dbbbf5d = function _1dbbbf5d() {
  return interopDefault(import('../pages/email-verification/backup-email/index.vue'
  /* webpackChunkName: "pages/email-verification/backup-email/index" */
  ));
};

var _5c3913c5 = function _5c3913c5() {
  return interopDefault(import('../pages/jobs/applications/index.vue'
  /* webpackChunkName: "pages/jobs/applications/index" */
  ));
};

var _4d66c48c = function _4d66c48c() {
  return interopDefault(import('../pages/profile/create.vue'
  /* webpackChunkName: "pages/profile/create" */
  ));
};

var _92ac9e74 = function _92ac9e74() {
  return interopDefault(import('../pages/profile/cv/index.vue'
  /* webpackChunkName: "pages/profile/cv/index" */
  ));
};

var _f5828ecc = function _f5828ecc() {
  return interopDefault(import('../pages/profile/edit.vue'
  /* webpackChunkName: "pages/profile/edit" */
  ));
};

var _c60ff186 = function _c60ff186() {
  return interopDefault(import('../pages/profile/progress.vue'
  /* webpackChunkName: "pages/profile/progress" */
  ));
};

var _716ac3d2 = function _716ac3d2() {
  return interopDefault(import('../pages/profile/cv/about-me/index.vue'
  /* webpackChunkName: "pages/profile/cv/about-me/index" */
  ));
};

var _c13d8ab4 = function _c13d8ab4() {
  return interopDefault(import('../pages/profile/cv/additional/index.vue'
  /* webpackChunkName: "pages/profile/cv/additional/index" */
  ));
};

var _cd2fafc2 = function _cd2fafc2() {
  return interopDefault(import('../pages/profile/cv/education/index.vue'
  /* webpackChunkName: "pages/profile/cv/education/index" */
  ));
};

var _a50ad374 = function _a50ad374() {
  return interopDefault(import('../pages/profile/cv/employability-awards/index.vue'
  /* webpackChunkName: "pages/profile/cv/employability-awards/index" */
  ));
};

var _7420ed2e = function _7420ed2e() {
  return interopDefault(import('../pages/profile/cv/fluent-languages/index.vue'
  /* webpackChunkName: "pages/profile/cv/fluent-languages/index" */
  ));
};

var _2528279d = function _2528279d() {
  return interopDefault(import('../pages/profile/cv/general-reference/index.vue'
  /* webpackChunkName: "pages/profile/cv/general-reference/index" */
  ));
};

var _0bdf99c0 = function _0bdf99c0() {
  return interopDefault(import('../pages/profile/cv/interests/index.vue'
  /* webpackChunkName: "pages/profile/cv/interests/index" */
  ));
};

var _16e54f01 = function _16e54f01() {
  return interopDefault(import('../pages/profile/cv/skills/index.vue'
  /* webpackChunkName: "pages/profile/cv/skills/index" */
  ));
};

var _6539bc39 = function _6539bc39() {
  return interopDefault(import('../pages/profile/cv/template/index.vue'
  /* webpackChunkName: "pages/profile/cv/template/index" */
  ));
};

var _8051eb40 = function _8051eb40() {
  return interopDefault(import('../pages/profile/cv/transport/index.vue'
  /* webpackChunkName: "pages/profile/cv/transport/index" */
  ));
};

var _03280c00 = function _03280c00() {
  return interopDefault(import('../pages/profile/cv/upload/index.vue'
  /* webpackChunkName: "pages/profile/cv/upload/index" */
  ));
};

var _06dd00c6 = function _06dd00c6() {
  return interopDefault(import('../pages/profile/cv/work-experience/index.vue'
  /* webpackChunkName: "pages/profile/cv/work-experience/index" */
  ));
};

var _88a1b474 = function _88a1b474() {
  return interopDefault(import('../pages/profile/cv/additional/achievement/index.vue'
  /* webpackChunkName: "pages/profile/cv/additional/achievement/index" */
  ));
};

var _26297fda = function _26297fda() {
  return interopDefault(import('../pages/profile/cv/additional/external-link/index.vue'
  /* webpackChunkName: "pages/profile/cv/additional/external-link/index" */
  ));
};

var _86a40c54 = function _86a40c54() {
  return interopDefault(import('../pages/profile/cv/additional/external-links/index.vue'
  /* webpackChunkName: "pages/profile/cv/additional/external-links/index" */
  ));
};

var _7a84e1ad = function _7a84e1ad() {
  return interopDefault(import('../pages/profile/cv/education/additional/index.vue'
  /* webpackChunkName: "pages/profile/cv/education/additional/index" */
  ));
};

var _2b2f963a = function _2b2f963a() {
  return interopDefault(import('../pages/profile/cv/education/school/index.vue'
  /* webpackChunkName: "pages/profile/cv/education/school/index" */
  ));
};

var _f4fc7250 = function _f4fc7250() {
  return interopDefault(import('../pages/profile/cv/education/tertiary/index.vue'
  /* webpackChunkName: "pages/profile/cv/education/tertiary/index" */
  ));
};

var _7c0e671a = function _7c0e671a() {
  return interopDefault(import('../pages/profile/cv/employability-awards/checklist.vue'
  /* webpackChunkName: "pages/profile/cv/employability-awards/checklist" */
  ));
};

var _663a98a6 = function _663a98a6() {
  return interopDefault(import('../pages/profile/cv/employability-awards/ChecklistItem.vue'
  /* webpackChunkName: "pages/profile/cv/employability-awards/ChecklistItem" */
  ));
};

var _150c6839 = function _150c6839() {
  return interopDefault(import('../pages/profile/cv/employability-awards/LogUpload.vue'
  /* webpackChunkName: "pages/profile/cv/employability-awards/LogUpload" */
  ));
};

var _3a37e1ae = function _3a37e1ae() {
  return interopDefault(import('../pages/profile/cv/additional/achievement/_id.vue'
  /* webpackChunkName: "pages/profile/cv/additional/achievement/_id" */
  ));
};

var _54602b3b = function _54602b3b() {
  return interopDefault(import('../pages/profile/cv/additional/external-link/_id.vue'
  /* webpackChunkName: "pages/profile/cv/additional/external-link/_id" */
  ));
};

var _116d2956 = function _116d2956() {
  return interopDefault(import('../pages/profile/cv/education/additional/_id.vue'
  /* webpackChunkName: "pages/profile/cv/education/additional/_id" */
  ));
};

var _0441df22 = function _0441df22() {
  return interopDefault(import('../pages/profile/cv/education/school/_id.vue'
  /* webpackChunkName: "pages/profile/cv/education/school/_id" */
  ));
};

var _48039f40 = function _48039f40() {
  return interopDefault(import('../pages/profile/cv/education/tertiary/_id.vue'
  /* webpackChunkName: "pages/profile/cv/education/tertiary/_id" */
  ));
};

var _ce352576 = function _ce352576() {
  return interopDefault(import('../pages/profile/cv/general-reference/_id.vue'
  /* webpackChunkName: "pages/profile/cv/general-reference/_id" */
  ));
};

var _6ac4c545 = function _6ac4c545() {
  return interopDefault(import('../pages/profile/cv/work-experience/_id.vue'
  /* webpackChunkName: "pages/profile/cv/work-experience/_id" */
  ));
};

var _2528c430 = function _2528c430() {
  return interopDefault(import('../pages/jobs/applications/_id/index.vue'
  /* webpackChunkName: "pages/jobs/applications/_id/index" */
  ));
};

var _8805cdb4 = function _8805cdb4() {
  return interopDefault(import('../pages/bursaries/_id/index.vue'
  /* webpackChunkName: "pages/bursaries/_id/index" */
  ));
};

var _74dec7b2 = function _74dec7b2() {
  return interopDefault(import('../pages/interviews/_id.vue'
  /* webpackChunkName: "pages/interviews/_id" */
  ));
};

var _469ff5a4 = function _469ff5a4() {
  return interopDefault(import('../pages/jobs/_id/index.vue'
  /* webpackChunkName: "pages/jobs/_id/index" */
  ));
};

var _3dcbf0e1 = function _3dcbf0e1() {
  return interopDefault(import('../pages/messages/_id.vue'
  /* webpackChunkName: "pages/messages/_id" */
  ));
};

var _43c81324 = function _43c81324() {
  return interopDefault(import('../pages/reset-password/_id.vue'
  /* webpackChunkName: "pages/reset-password/_id" */
  ));
};

var _93eb75b2 = function _93eb75b2() {
  return interopDefault(import('../pages/bursaries/_id/application/index.vue'
  /* webpackChunkName: "pages/bursaries/_id/application/index" */
  ));
};

var _cc5935a2 = function _cc5935a2() {
  return interopDefault(import('../pages/jobs/_id/application/index.vue'
  /* webpackChunkName: "pages/jobs/_id/application/index" */
  ));
};

var _2b985950 = function _2b985950() {
  return interopDefault(import('../pages/index.vue'
  /* webpackChunkName: "pages/index" */
  ));
};

var emptyFn = function emptyFn() {};

Vue.use(Router);
export var routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior: scrollBehavior,
  routes: [{
    path: "/account-verification",
    component: _2e37aa30,
    name: "account-verification___en"
  }, {
    path: "/af/account-verification",
    component: _2e37aa30,
    name: "account-verification___af"
  }, {
    path: "/bursaries",
    component: _563a53bb,
    name: "bursaries___en"
  }, {
    path: "/af/bursaries",
    component: _563a53bb,
    name: "bursaries___af"
  }, {
    path: "/courses",
    component: _cf6eb07e,
    name: "courses___en"
  }, {
    path: "/af/courses",
    component: _cf6eb07e,
    name: "courses___af"
  }, {
    path: "/events",
    component: _17e7f774,
    name: "events___en"
  }, {
    path: "/af/events",
    component: _17e7f774,
    name: "events___af"
  }, {
    path: "/faqs",
    component: _a0489a6c,
    name: "faqs___en"
  }, {
    path: "/af/faqs",
    component: _a0489a6c,
    name: "faqs___af"
  }, {
    path: "/forgot-password",
    component: _276fa864,
    name: "forgot-password___en"
  }, {
    path: "/af/forgot-password",
    component: _276fa864,
    name: "forgot-password___af"
  }, {
    path: "/general-preferences",
    component: _67e3d248,
    name: "general-preferences___en"
  }, {
    path: "/af/general-preferences",
    component: _67e3d248,
    name: "general-preferences___af"
  }, {
    path: "/interviews",
    component: _5879b402,
    name: "interviews___en"
  }, {
    path: "/af/interviews",
    component: _5879b402,
    name: "interviews___af"
  }, {
    path: "/jobs",
    component: _61d6f87a,
    name: "jobs___en"
  }, {
    path: "/af/jobs",
    component: _61d6f87a,
    name: "jobs___af"
  }, {
    path: "/LoadTest",
    component: _662c15a2,
    name: "LoadTest___en"
  }, {
    path: "/af/LoadTest",
    component: _662c15a2,
    name: "LoadTest___af"
  }, {
    path: "/login",
    component: _468b2db2,
    name: "login___en"
  }, {
    path: "/af/login",
    component: _468b2db2,
    name: "login___af"
  }, {
    path: "/messages",
    component: _2a7c3439,
    name: "messages___en"
  }, {
    path: "/af/messages",
    component: _2a7c3439,
    name: "messages___af"
  }, {
    path: "/mock-interviews",
    component: _053754fe,
    name: "mock-interviews___en"
  }, {
    path: "/af/mock-interviews",
    component: _053754fe,
    name: "mock-interviews___af"
  }, {
    path: "/my-details",
    component: _bc4c9164,
    name: "my-details___en"
  }, {
    path: "/af/my-details",
    component: _bc4c9164,
    name: "my-details___af"
  }, {
    path: "/my-jobs",
    component: _68d8c520,
    name: "my-jobs___en"
  }, {
    path: "/af/my-jobs",
    component: _68d8c520,
    name: "my-jobs___af"
  }, {
    path: "/notification-preferences",
    component: _23ec0b83,
    name: "notification-preferences___en"
  }, {
    path: "/af/notification-preferences",
    component: _23ec0b83,
    name: "notification-preferences___af"
  }, {
    path: "/notifications",
    component: _1b27f271,
    name: "notifications___en"
  }, {
    path: "/af/notifications",
    component: _1b27f271,
    name: "notifications___af"
  }, {
    path: "/saved-jobs",
    component: _d91f436e,
    name: "saved-jobs___en"
  }, {
    path: "/af/saved-jobs",
    component: _d91f436e,
    name: "saved-jobs___af"
  }, {
    path: "/settings",
    component: _b588e360,
    name: "settings___en"
  }, {
    path: "/af/settings",
    component: _b588e360,
    name: "settings___af"
  }, {
    path: "/university-management",
    component: _c23d582a,
    name: "university-management___en"
  }, {
    path: "/af/university-management",
    component: _c23d582a,
    name: "university-management___af"
  }, {
    path: "/welcome",
    component: _102512eb,
    name: "welcome___en"
  }, {
    path: "/af/welcome",
    component: _102512eb,
    name: "welcome___af"
  }, {
    path: "/account/create",
    component: _e8c9ecf0,
    name: "account-create___en"
  }, {
    path: "/af/account/create",
    component: _e8c9ecf0,
    name: "account-create___af"
  }, {
    path: "/account/edit",
    component: _a70fe6d4,
    name: "account-edit___en"
  }, {
    path: "/af/account/edit",
    component: _a70fe6d4,
    name: "account-edit___af"
  }, {
    path: "/account/verify-university",
    component: _da7454f4,
    name: "account-verify-university___en"
  }, {
    path: "/af/account/verify-university",
    component: _da7454f4,
    name: "account-verify-university___af"
  }, {
    path: "/email-verification/backup-email",
    component: _1dbbbf5d,
    name: "email-verification-backup-email___en"
  }, {
    path: "/af/email-verification/backup-email",
    component: _1dbbbf5d,
    name: "email-verification-backup-email___af"
  }, {
    path: "/jobs/applications",
    component: _5c3913c5,
    name: "jobs-applications___en"
  }, {
    path: "/af/jobs/applications",
    component: _5c3913c5,
    name: "jobs-applications___af"
  }, {
    path: "/profile/create",
    component: _4d66c48c,
    name: "profile-create___en"
  }, {
    path: "/af/profile/create",
    component: _4d66c48c,
    name: "profile-create___af"
  }, {
    path: "/profile/cv",
    component: _92ac9e74,
    name: "profile-cv___en"
  }, {
    path: "/af/profile/cv",
    component: _92ac9e74,
    name: "profile-cv___af"
  }, {
    path: "/profile/edit",
    component: _f5828ecc,
    name: "profile-edit___en"
  }, {
    path: "/af/profile/edit",
    component: _f5828ecc,
    name: "profile-edit___af"
  }, {
    path: "/profile/progress",
    component: _c60ff186,
    name: "profile-progress___en"
  }, {
    path: "/af/profile/progress",
    component: _c60ff186,
    name: "profile-progress___af"
  }, {
    path: "/profile/cv/about-me",
    component: _716ac3d2,
    name: "profile-cv-about-me___en"
  }, {
    path: "/af/profile/cv/about-me",
    component: _716ac3d2,
    name: "profile-cv-about-me___af"
  }, {
    path: "/profile/cv/additional",
    component: _c13d8ab4,
    name: "profile-cv-additional___en"
  }, {
    path: "/af/profile/cv/additional",
    component: _c13d8ab4,
    name: "profile-cv-additional___af"
  }, {
    path: "/profile/cv/education",
    component: _cd2fafc2,
    name: "profile-cv-education___en"
  }, {
    path: "/af/profile/cv/education",
    component: _cd2fafc2,
    name: "profile-cv-education___af"
  }, {
    path: "/profile/cv/employability-awards",
    component: _a50ad374,
    name: "profile-cv-employability-awards___en"
  }, {
    path: "/af/profile/cv/employability-awards",
    component: _a50ad374,
    name: "profile-cv-employability-awards___af"
  }, {
    path: "/profile/cv/fluent-languages",
    component: _7420ed2e,
    name: "profile-cv-fluent-languages___en"
  }, {
    path: "/af/profile/cv/fluent-languages",
    component: _7420ed2e,
    name: "profile-cv-fluent-languages___af"
  }, {
    path: "/profile/cv/general-reference",
    component: _2528279d,
    name: "profile-cv-general-reference___en"
  }, {
    path: "/af/profile/cv/general-reference",
    component: _2528279d,
    name: "profile-cv-general-reference___af"
  }, {
    path: "/profile/cv/interests",
    component: _0bdf99c0,
    name: "profile-cv-interests___en"
  }, {
    path: "/af/profile/cv/interests",
    component: _0bdf99c0,
    name: "profile-cv-interests___af"
  }, {
    path: "/profile/cv/skills",
    component: _16e54f01,
    name: "profile-cv-skills___en"
  }, {
    path: "/af/profile/cv/skills",
    component: _16e54f01,
    name: "profile-cv-skills___af"
  }, {
    path: "/profile/cv/template",
    component: _6539bc39,
    name: "profile-cv-template___en"
  }, {
    path: "/af/profile/cv/template",
    component: _6539bc39,
    name: "profile-cv-template___af"
  }, {
    path: "/profile/cv/transport",
    component: _8051eb40,
    name: "profile-cv-transport___en"
  }, {
    path: "/af/profile/cv/transport",
    component: _8051eb40,
    name: "profile-cv-transport___af"
  }, {
    path: "/profile/cv/upload",
    component: _03280c00,
    name: "profile-cv-upload___en"
  }, {
    path: "/af/profile/cv/upload",
    component: _03280c00,
    name: "profile-cv-upload___af"
  }, {
    path: "/profile/cv/work-experience",
    component: _06dd00c6,
    name: "profile-cv-work-experience___en"
  }, {
    path: "/af/profile/cv/work-experience",
    component: _06dd00c6,
    name: "profile-cv-work-experience___af"
  }, {
    path: "/profile/cv/additional/achievement",
    component: _88a1b474,
    name: "profile-cv-additional-achievement___en"
  }, {
    path: "/af/profile/cv/additional/achievement",
    component: _88a1b474,
    name: "profile-cv-additional-achievement___af"
  }, {
    path: "/profile/cv/additional/external-link",
    component: _26297fda,
    name: "profile-cv-additional-external-link___en"
  }, {
    path: "/af/profile/cv/additional/external-link",
    component: _26297fda,
    name: "profile-cv-additional-external-link___af"
  }, {
    path: "/profile/cv/additional/external-links",
    component: _86a40c54,
    name: "profile-cv-additional-external-links___en"
  }, {
    path: "/af/profile/cv/additional/external-links",
    component: _86a40c54,
    name: "profile-cv-additional-external-links___af"
  }, {
    path: "/profile/cv/education/additional",
    component: _7a84e1ad,
    name: "profile-cv-education-additional___en"
  }, {
    path: "/af/profile/cv/education/additional",
    component: _7a84e1ad,
    name: "profile-cv-education-additional___af"
  }, {
    path: "/profile/cv/education/school",
    component: _2b2f963a,
    name: "profile-cv-education-school___en"
  }, {
    path: "/af/profile/cv/education/school",
    component: _2b2f963a,
    name: "profile-cv-education-school___af"
  }, {
    path: "/profile/cv/education/tertiary",
    component: _f4fc7250,
    name: "profile-cv-education-tertiary___en"
  }, {
    path: "/af/profile/cv/education/tertiary",
    component: _f4fc7250,
    name: "profile-cv-education-tertiary___af"
  }, {
    path: "/profile/cv/employability-awards/checklist",
    component: _7c0e671a,
    name: "profile-cv-employability-awards-checklist___en"
  }, {
    path: "/af/profile/cv/employability-awards/checklist",
    component: _7c0e671a,
    name: "profile-cv-employability-awards-checklist___af"
  }, {
    path: "/profile/cv/employability-awards/ChecklistItem",
    component: _663a98a6,
    name: "profile-cv-employability-awards-ChecklistItem___en"
  }, {
    path: "/af/profile/cv/employability-awards/ChecklistItem",
    component: _663a98a6,
    name: "profile-cv-employability-awards-ChecklistItem___af"
  }, {
    path: "/profile/cv/employability-awards/LogUpload",
    component: _150c6839,
    name: "profile-cv-employability-awards-LogUpload___en"
  }, {
    path: "/af/profile/cv/employability-awards/LogUpload",
    component: _150c6839,
    name: "profile-cv-employability-awards-LogUpload___af"
  }, {
    path: "/profile/cv/additional/achievement/:id",
    component: _3a37e1ae,
    name: "profile-cv-additional-achievement-id___en"
  }, {
    path: "/af/profile/cv/additional/achievement/:id",
    component: _3a37e1ae,
    name: "profile-cv-additional-achievement-id___af"
  }, {
    path: "/profile/cv/additional/external-link/:id?",
    component: _54602b3b,
    name: "profile-cv-additional-external-link-id___en"
  }, {
    path: "/af/profile/cv/additional/external-link/:id?",
    component: _54602b3b,
    name: "profile-cv-additional-external-link-id___af"
  }, {
    path: "/profile/cv/education/additional/:id",
    component: _116d2956,
    name: "profile-cv-education-additional-id___en"
  }, {
    path: "/af/profile/cv/education/additional/:id",
    component: _116d2956,
    name: "profile-cv-education-additional-id___af"
  }, {
    path: "/profile/cv/education/school/:id",
    component: _0441df22,
    name: "profile-cv-education-school-id___en"
  }, {
    path: "/af/profile/cv/education/school/:id",
    component: _0441df22,
    name: "profile-cv-education-school-id___af"
  }, {
    path: "/profile/cv/education/tertiary/:id",
    component: _48039f40,
    name: "profile-cv-education-tertiary-id___en"
  }, {
    path: "/af/profile/cv/education/tertiary/:id",
    component: _48039f40,
    name: "profile-cv-education-tertiary-id___af"
  }, {
    path: "/profile/cv/general-reference/:id?",
    component: _ce352576,
    name: "profile-cv-general-reference-id___en"
  }, {
    path: "/af/profile/cv/general-reference/:id?",
    component: _ce352576,
    name: "profile-cv-general-reference-id___af"
  }, {
    path: "/profile/cv/work-experience/:id?",
    component: _6ac4c545,
    name: "profile-cv-work-experience-id___en"
  }, {
    path: "/af/profile/cv/work-experience/:id?",
    component: _6ac4c545,
    name: "profile-cv-work-experience-id___af"
  }, {
    path: "/jobs/applications/:id",
    component: _2528c430,
    name: "jobs-applications-id___en"
  }, {
    path: "/af/jobs/applications/:id",
    component: _2528c430,
    name: "jobs-applications-id___af"
  }, {
    path: "/bursaries/:id",
    component: _8805cdb4,
    name: "bursaries-id___en"
  }, {
    path: "/af/bursaries/:id",
    component: _8805cdb4,
    name: "bursaries-id___af"
  }, {
    path: "/interviews/:id",
    component: _74dec7b2,
    name: "interviews-id___en"
  }, {
    path: "/af/interviews/:id",
    component: _74dec7b2,
    name: "interviews-id___af"
  }, {
    path: "/jobs/:id",
    component: _469ff5a4,
    name: "jobs-id___en"
  }, {
    path: "/af/jobs/:id",
    component: _469ff5a4,
    name: "jobs-id___af"
  }, {
    path: "/messages/:id",
    component: _3dcbf0e1,
    name: "messages-id___en"
  }, {
    path: "/af/messages/:id",
    component: _3dcbf0e1,
    name: "messages-id___af"
  }, {
    path: "/reset-password/:id?",
    component: _43c81324,
    name: "reset-password-id___en"
  }, {
    path: "/af/reset-password/:id?",
    component: _43c81324,
    name: "reset-password-id___af"
  }, {
    path: "/bursaries/:id/application",
    component: _93eb75b2,
    name: "bursaries-id-application___en"
  }, {
    path: "/af/bursaries/:id/application",
    component: _93eb75b2,
    name: "bursaries-id-application___af"
  }, {
    path: "/jobs/:id/application",
    component: _cc5935a2,
    name: "jobs-id-application___en"
  }, {
    path: "/af/jobs/:id/application",
    component: _cc5935a2,
    name: "jobs-id-application___af"
  }, {
    path: "/",
    component: _2b985950,
    name: "index___en"
  }, {
    path: "/af",
    component: _2b985950,
    name: "index___af"
  }],
  fallback: false
};
export function createRouter(ssrContext, config) {
  var base = config._app && config._app.basePath || routerOptions.base;
  var router = new Router(_objectSpread(_objectSpread({}, routerOptions), {}, {
    base: base
  })); // TODO: remove in Nuxt 3

  var originalPush = router.push;

  router.push = function push(location) {
    var onComplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyFn;
    var onAbort = arguments.length > 2 ? arguments[2] : undefined;
    return originalPush.call(this, location, onComplete, onAbort);
  };

  var resolve = router.resolve.bind(router);

  router.resolve = function (to, current, append) {
    if (typeof to === 'string') {
      to = normalizeURL(to);
    }

    return resolve(to, current, append);
  };

  return router;
}